import { useState } from 'react';
import { Button } from '@chakra-ui/react';

import { Modal, Input } from 'shared-components';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../store';

export interface IProps {
  value: string;
  onChange: (value: string) => void;
  onClose: () => void;
}

const ChangeIntakeModal = (props: IProps) => {
  const { value, onChange, onClose } = props;
  const [studentNo, setStudentNo] = useState(value);
  const openedStudentNumber = useSelector((state: ApplicationState) => state.student.core.student_number);

  const onChangeStudentNo = (value: string) => {
    setStudentNo(value);
  };

  const isBtnDisabled = !studentNo || openedStudentNumber === studentNo || studentNo.includes(' ');
  return (
    <Modal
      id="change-student-number-modal"
      show={true}
      title={'Change student number'}
      onClose={onClose}
      size="md"
      footer={
        <Button
          id="change-student-number-button"
          onClick={() => {
            onChange(studentNo);
          }}
          variant={'solid'}
          size={'lg'}
          isDisabled={isBtnDisabled}
        >
          Change
        </Button>
      }
    >
      <Input
        value={studentNo}
        placeHolder=""
        onChange={(event: any) => onChangeStudentNo(event.currentTarget.value)}
        autoFocus={true}
      />
    </Modal>
  );
};

export default ChangeIntakeModal;
